import React, { Component } from 'react';
import './Popup.module.scss';

class Popup extends Component {
    constructor() {
        super();

        this.handleClose = this.handleClose.bind(this);
    }

    handleClose(event) {

        this.props.handleClose();
    }

    render() {
        const { visible } = this.props;
        return (
            <div onClick={this.handleClose && this.handleClose} styleName={'popup-background ' + (visible ? 'visible' : '')}>
                <div styleName="popup-content">
                    {this.props.children}
                </div>
            </div>

        );
    }
}

export default Popup;